import { Bounce, ToastContainer } from "react-toastify";
import { RecoilRoot } from "recoil";
import PropTypes from "prop-types";
import { BrowserRouter } from "react-router-dom";
import { App } from "App";

import "./index.scss";
import "react-toastify/dist/ReactToastify.css";
import "remixicon/fonts/remixicon.css";
import "@tensorflow/tfjs-backend-webgl";
import * as tfjsWasm from "@tensorflow/tfjs-backend-wasm";
import "@tensorflow-models/face-detection";

tfjsWasm.setWasmPaths(
  `https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${tfjsWasm.version_wasm}/dist/`
);

export const BankLogin = ({
  mobile_number,
  country_code,
  on_success,
  on_failed,
  on_back,
  face_recognition,
  is_redirect_auth,
  is_recipient,
  is_message_send,
}: any) => {
  console.log('is_recipient',on_success)
  const props = {
    mobileNumber: mobile_number,
    countryCode: country_code,
    onSuccess: on_success,
    onFailed: on_failed,
    onBack: on_back,
    face_recognition,
    is_redirect_auth,
    is_recipient: is_recipient === "true",
    is_message_send: is_message_send === "true" 

  };
  console.log('props', props)
  return (
    <RecoilRoot>
      <BrowserRouter>
        <App {...props} />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          transition={Bounce}
          theme="dark"
          limit={1}
        />
      </BrowserRouter>
    </RecoilRoot>
  );
};

BankLogin.propTypes = {
  mobile_number: PropTypes.string,
  country_code: PropTypes.string,
  on_success: PropTypes.func.isRequired,
  on_failed: PropTypes.func.isRequired,
  on_back: PropTypes.func,
  is_recipient: PropTypes.string,
  is_message_send: PropTypes.string
};
